/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type NameChangeFeeMode = typeof NameChangeFeeMode[keyof typeof NameChangeFeeMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NameChangeFeeMode = {
  PerFlightAndPerson: 'PerFlightAndPerson',
  PerPnrAndPerson: 'PerPnrAndPerson',
} as const;
